<div class="col-span-1">
    <div class="bg-white dark:bg-[#111] text-gray-900 dark:text-gray-100 shadow-md rounded-xl p-5 mb-0 cursor-pointer will-change-transform" style="transform: translateZ(0)" [routerLink]="[route]">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-gray-500 dark:text-gray-400 font-medium mb-4">{{ subtitle }}</span>
                <div class="font-medium text-xl">{{ title }}</div>
            </div>
            <div class="flex items-center justify-center rounded-border" [ngClass]="iconColor" style="width: 2.5rem; height: 2.5rem">
                <i class="pi" [ngClass]="icon + ' !text-xl'"></i>
            </div>
        </div>
        <div class="relative w-full">
                        @if (loading) {
                            <div class="absolute inset-0 bg-gray-200 dark:bg-zinc-800 animate-pulse rounded-md"></div>
                        }
            <img [src]="image" alt="Imagen" class="image-hover w-70 h-60 object-cover mx-auto rounded-md" (load)="onImgLoad()" [style.opacity]="loading ? 0 : 1" />
        </div>
    </div>
</div>